export class By {
  public static css(selector: string) {
    return selector;
  }
}
